// extracted by mini-css-extract-plugin
export default {"wrap":"AF-z","subtitle":"BF-z","contentWrap":"CF-z","imgWrap":"DF-z","heading":"EF-z","copy":"FF-z"};